import axios from 'axios'

export const handleResponse = (response: any) => {
    if (response.data) {
        return response.data
    }
    throw response
}

export const handleError = (error: any) => {

    if (axios.isCancel(error)) {
        console.log(error)
    } else {
        console.log('出错了')
    }

    return Promise.reject(error)

}